import React, { useState, useEffect, useCallback } from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import {
  Box,
  BoxProps,
  ButtonBase,
  Container,
  Grid,
  useMediaQuery,
} from '@mui/material'
import fast from '@meprism/shared/src/assets/icons/fast.svg'
import Link from '@mui/material/Link'
import AI from '@meprism/shared/src/assets/icons/AI.svg'
import Realtime from '@meprism/shared/src/assets/icons/Realtime.svg'
import logo from '@meprism/shared/src/assets/icons/logos/mePrismprivacynew.svg'
import background from '../../assets/images/IndividualCreateBackground.png'
import { ThemeProvider } from '@emotion/react'
import { theme } from '../../theme/OnboardingTheme'
import icon4 from '@meprism/shared/src/assets/icons/lucide_scan-text.svg'
import icon5 from '@meprism/shared/src/assets/icons/no.svg'
import { Toast } from '../toast/toast'
import { useAppDispatch } from '../../redux/storeExports'
import {UpdateEmailSubscription} from '@meprism/shared/src/redux/email/EmailSlice'
import { decodeString, validateEmail } from '../../utils/helpers'
import {EmailTemplateType} from '@meprism/shared/src/redux/email/EmailTypes'
import CircularProgress from '@mui/material/CircularProgress';

function Item(props: BoxProps) {
  const { ...other } = props
  return <Box {...other} />
}


const EmailUnsubscribeView = () => {
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const params = new URLSearchParams(window.location.search);
    const encodedString = params.get('data') || ''
    const dispatch = useAppDispatch()
    const [templateType, setTemplateType] = useState('');
    const [email, setEmail] = useState('')
    const [unsubscribeDisable, setUnsubscribeDisable] = useState(false)
    const [requestLoading, setRequestLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [isInvalidContent, setIsInvalidContent] = useState(false)
    const validateData = useCallback((data: any)=> 
    !!(data.email && data.template_type && validateEmail(data.email) && validateTemplateType(data.template_type)),[]);

    const validateTemplateType=(templateTypeString: string)=>{
        return Object.values(EmailTemplateType).includes(templateTypeString as EmailTemplateType);
    }

    useEffect(()=>{
        if(encodedString){
            try{
                const data = decodeString(encodedString)
                if(data && validateData(data)){
                    setTemplateType(data.template_type)
                    setEmail(data.email)
                }else{
                    setIsInvalidContent(true)
                }
            }
            catch(e){
                //to catch invalid encoding
                console.error('error decoding query string: ', e)
                setIsInvalidContent(true)
            }finally{
                setIsLoading(false)
            }
        }else{
            setIsInvalidContent(true)
            setIsLoading(false)
        }
    },[encodedString, validateData])

    const handleSubmit = () =>{
        if(email && templateType){
            if(!validateEmail(email)){
                Toast.show({
                    type: 'error',
                    text1: 'No valid email found.'
                })
                return
            }
            unsubscribeEmail()
        }else{
            Toast.show({
                type: 'error',
                text1: 'No valid email found.'
            })
        }
    }

    const unsubscribeEmail = async () => {
        setRequestLoading(true)
        setUnsubscribeDisable(true)
        await dispatch(UpdateEmailSubscription({
            email: email,
            template_type: templateType as EmailTemplateType,
        }
        ))
        setRequestLoading(false)
        setUnsubscribeDisable(false)
    };


    const AuthCopy = () => {
    return (
        <>
        <ThemeProvider theme={theme}> 
            <Box sx={{ px: 10, pt: 10 }}>
                <a href="https://meprism.com/" target="_blank" rel="noreferrer">
                <img src={logo} alt="Logo" style={{ width: 250, height: 100 }} />
                </a>
            </Box>
            <Stack
            sx={{
                px: 10,
                pt: 10,
                '& .MuiTypography-root': {
                color: '#FFFFFF',
                },
                justifyContent: 'start',
                height: '100vh',
                overflow: 'hidden'
            }}>
                <Typography
                    variant={'h1'}
                    sx={{
                    my: 2,
                    fontWeight: 'bold',
                    maxWidth: !isMobile ? '400px' : 'unset',
                    }}>
                    Why choose Priwall?
                </Typography>
                <Box
                    sx={{
                    display: 'flex',
                    columnGap: 1,
                    rowGap: 1,
                    alignItems: 'center',
                    gridTemplateColumns: 'auto, 5fr',
                    }}>
                    <Item>
                    <img
                        src={fast}
                        alt="Logo"
                        style={{ marginRight: 8, width: 42, height: 42 }}
                    />
                    </Item>
                    <Item>
                    {' '}
                    <Typography variant="body2">
                        Fast, continuous removal{' '}
                        <span style={{ color: '#EFEDFDB2' }}>
                        of personal data (PII) from the web
                        </span>
                    </Typography>{' '}
                    </Item>
                </Box>
                <Box
                    sx={{
                    display: 'flex',
                    columnGap: 1,
                    rowGap: 1,
                    alignItems: 'center',
                    gridTemplateColumns: 'auto, 1fr',
                    }}>
                    <Item>
                    <img
                        src={Realtime}
                        alt="Logo"
                        style={{ marginRight: 8, width: 42, height: 42 }}
                    />
                    </Item>
                    <Item sx={{ gridColumn: 'span 5' }}>
                    <Typography variant="body2">
                        Real-time monitoring{' '}
                        <span style={{ color: '#EFEDFDB2' }}>& reporting </span>
                    </Typography>{' '}
                    </Item>
                </Box>
                <Box
                    sx={{
                    display: 'flex',
                    columnGap: 1,
                    rowGap: 1,
                    gridTemplateColumns: 'auto, 1fr',
                    alignItems: 'center',
                    }}>
                    <Item>
                    <img
                        src={AI}
                        alt="Logo"
                        style={{ marginRight: 8, width: 42, height: 42 }}
                    />
                    </Item>
                    <Item>
                    <Typography variant="body2">
                        <span style={{ color: '#EFEDFDB2' }}> Powered by </span>
                        automation and AI +{' '}
                        <span style={{ color: '#EFEDFDB2' }}>
                        legal intervention
                        </span>{' '}
                    </Typography>
                    </Item>
                </Box>
                <Box
                sx={{
                alignItems: 'left',
                marginTop: 4,
                p: 10,
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                border:
                    '2px solid var(--text-colors-stroke, rgba(255, 255, 255, 0.15))',
                borderRadius: '20px',
                backdropFilter: 'blur(20.5px)',
                }}>
                    <Typography variant="h4">
                    Information <span style={{ color: '#C67EFF' }}>Security</span>
                    </Typography>
                    <Grid
                        container
                        spacing={4}
                        sx={{
                            flexDirection: { xs: 'column', md: 'row' },
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            marginTop: 4,
                        }}
                        >
                        {/* Item 1 */}
                        <Grid item xs={12} md={6}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                            <img
                                src={icon4}
                                alt="Icon2"
                                style={{
                                verticalAlign: 'middle',
                                marginRight: 8,
                                width: 24,
                                height: 24,
                                }}
                            />
                            <Typography variant="body3">
                                Priwall is SOC 2 compliant with industry-grade cybersecurity standards for handling sensitive data
                            </Typography>
                            </Box>
                        </Grid>

                        {/* Item 2 */}
                        <Grid item xs={12} md={6}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', marginTop: isMobile ? 4 : 0 }}>
                                <img
                                    src={icon5}
                                    alt="Icon2"
                                    style={{
                                    verticalAlign: 'middle',
                                    marginRight: 8,
                                    width: 24,
                                    height: 24,
                                    marginLeft: 5,
                                    }}
                                />
                                <Typography variant="body3">
                                    We are a privacy agent. We will never share or sell the information you provide to us. All the data you provide during onboarding is used for the sole expressed purpose of finding and removing your information.
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Stack>
        </ThemeProvider>
    </>
    )
    }

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth={false} sx={{ background: '#fff', position: 'relative', overflow: { xs: 'auto', md: 'hidden' }, height: '100vh' }} disableGutters>
        <Grid container sx={{ minHeight: '100vh' }}>
          <Grid item xs={12} md={5}>
                <Box sx={{display:'flex', flexDirection:'column', justifyContent:'center', px: isMobile?8:30, py: isMobile?5:50}}>
                    {isLoading?
                    <div style={{marginTop: 100, marginBottom: 70, alignSelf:'center'}}>
                        <CircularProgress color = 'secondary'></CircularProgress>
                    </div>:
                    isInvalidContent?
                    <>
                        <Typography variant='h2' color={'black'} mt={50} textAlign={'center'}>
                            No Valid Data Found
                        </Typography>
                    </>:
                    <>
                    <Typography variant='h2' color={'black'} mt={5}>
                        Unsubscribe from Priwall emails
                    </Typography>
                    <Typography variant='body1' color={'black'} my={5} fontSize={20}>
                        You will be unsubscribed from all Priwall emails.
                    </Typography>
                    
                   <ButtonBase
						onClick={() => {
							handleSubmit()						
						}}
						sx={{background: 'black',
                            border: '1px solid black',
                            borderRadius: 2,
                            color: 'white',
                            py: 2,
                            display: 'flex !important',
                            justifyContent: 'center !important',
                            alignItems: 'center !important',
                            gap: '10px !important',
                            '& .MuiCircularProgress-root': {
                                color: '#fff !important',
                                width: '20px !important',
                                height: '20px !important',
                            }, 
                        }}
                        disabled={unsubscribeDisable}
                        >
						<Typography variant={'h4'}>
							Unsubscribe {requestLoading && <CircularProgress color='secondary'/>}
						</Typography>
					</ButtonBase>
                    </>}
                    <Typography variant='body1' color={'balck'} fontSize={'18px'} mt={10} textAlign={'center'}>
                        Go to {''}
                        <Link
                            href={'https://app.meprism.com/'}
                            sx={{
                                textDecoration:'underline !important',
                                color: 'black',
                                fontSize: {
                                    md:'18px',
                                    sm: '18px',
                                    xs:'18px'
                                }
                            }}>
                            Priwall
                        </Link>
                    </Typography>
                </Box>
          </Grid>
          <Grid
            item
            xs={0}
            md={7}
            sx={{
              backgroundImage: `url(${background})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              width:'100%',
              alignItems: 'flex-end',
              overflow: 'hidden',
              height: '100vh',
            }}>
              <Box sx={{position:'relative',height:'100%', overflow: 'hidden'}}>
            <AuthCopy />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </ThemeProvider>
  )
}

export default EmailUnsubscribeView;
